import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@shared/methods/methods';

@Pipe({
  name: 'yearsOld',
})
export class YearsOldPipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      const date = formatDate(
        new Date(value),
        [{ month: 'short' }, { year: 'numeric' }],
        ' '
      );
      const dateYear = new Date(value).getFullYear();
      const currentDateYear = new Date().getFullYear();
      const yearsOld = currentDateYear - dateYear;
      const yearsOldText = yearsOld >= 2 ? 'years' : 'year';
      return `${date} (${yearsOld}) ${yearsOldText}`;
    }
  }
}
